export default __webpack_public_path__ + "static/media/19t.01fa24c6.jpg";